/** Expecting to have class of title and content, content
 *  is dynamic based on clicking of the title link
 */
import {Component, Input} from '@angular/core';

@Component({
  selector: 'ox-tooltip',
  templateUrl: './tooltip.component.html'
})
export class TooltipComponent {
  @Input() cmsParams = '';
  @Input() track = '';
  @Input() trackDelay = '';
  @Input() trackType = '';
  @Input() trackEvent = '';
  @Input() prop10 = '';
  @Input() evar33 = '';
  @Input() prop15 = '';
  @Input() trackFirstClickOnly = '';

  public title = '';
  public contentElem = '';
  public showToolTip = false;

  triggerToolTip() {
    this.showToolTip = !this.showToolTip;
  }
}
